module.exports = "//public.zight.com/packs/media/images/parallax-76a24924bc1536861f9252b98e4e8130.jpg";